import SalesforceSourceIcon from "../../assets/components/sources/SalesforceSourceIcon";

const SalesforceLogomark = ({ height }: { height: number }) => {
  return <SalesforceSourceIcon height={height} />;
};

export default SalesforceLogomark;
